import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { barConfig } from '@workers';
import { ChartConfiguration, ChartType } from 'chart.js';
import { BaseChartDirective, NgChartsModule } from 'ng2-charts';

@Component({
  selector: 'app-bar-chart',
  templateUrl: './bar-chart.component.html',
  styleUrls: ['./bar-chart.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgChartsModule],
})
export class BarChartComponent implements OnChanges {
  @ViewChild(BaseChartDirective) chart?: BaseChartDirective;

  chartType: ChartType = 'bar';

  @Input() actionGroupIndex: number;

  @Input() lineChartOptions: ChartConfiguration['options'] = barConfig;

  @Input() data: ChartConfiguration['data'];

  @Output() clickOnErrorChart = new EventEmitter<{
    timeIndex: number;
    actionGroupIndex: number;
  }>();

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['data']?.currentValue) return;
    if (this.chart?.chart) {
      this.chart.chart.data = changes['data'].currentValue;
    }
    this.chart?.update();
  }

  onChartClick(event: any): void {
    const target = event.active[0];
    if (target) {
      this.clickOnErrorChart.emit({
        timeIndex: target.index,
        actionGroupIndex: this.actionGroupIndex,
      });
    }
  }
}
